// src/components/CallToAction.jsx - COMPLETELY REDESIGNED
import React from 'react';
import { useNavigate } from 'react-router-dom';

var isGJ = false;

const CallToAction = () => {
  const navigate = useNavigate();
  const domain = window.location.hostname;
  
  if (domain.includes("gojuris.ai")) {
    isGJ = true;
  }

  return (
    <section className="modern-cta-section">
      <div className="container">
        <div className="cta-card-modern">
          {/* Background Decorations */}
          <div className="cta-decoration decoration-1"></div>
          <div className="cta-decoration decoration-2"></div>
          <div className="cta-decoration decoration-3"></div>

          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-7">
              <div className="cta-content">
                <div className="cta-badge">
                  <i className="bx bx-rocket"></i>
                  <span>Start Your Journey</span>
                </div>

                <h2 className="cta-title">
                  Ready to Transform Your <span className="gradient-text-white">Legal Research?</span>
                </h2>

                <p className="cta-description">
                  Join thousands of legal professionals who trust {isGJ ? 'LJSoft Online' : 'LJSoft Online'} 
                  for faster, smarter, and more accurate legal research.
                </p>

                {/* Benefits List */}
                <div className="cta-benefits">
                  <div className="benefit-item">
                    <i className="bx bx-check-circle"></i>
                    <span>No credit card required</span>
                  </div>
                  <div className="benefit-item">
                    <i className="bx bx-check-circle"></i>
                    <span>Free trial available</span>
                  </div>
                  <div className="benefit-item">
                    <i className="bx bx-check-circle"></i>
                    <span>Cancel anytime</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Actions */}
            <div className="col-lg-5">
              <div className="cta-actions">
                <button
                  className="cta-button primary-btn"
                  onClick={() => navigate('/signup')}
                >
                  <span>Get Started Free</span>
                  <i className="bx bx-right-arrow-alt"></i>
                </button>

                <button
                  className="cta-button secondary-btn"
                  onClick={() => navigate('/pricing')}
                >
                  <span>View Pricing Plans</span>
                  <i className="bx bx-credit-card"></i>
                </button>

                <div className="cta-trust">
                  <div className="trust-avatars">
                    <div className="avatar">👨‍💼</div>
                    <div className="avatar">👩‍💼</div>
                    <div className="avatar">👨‍⚖️</div>
                    <div className="avatar">👩‍⚖️</div>
                  </div>
                  <div className="trust-text">
                    <strong>5,000+ legal professionals</strong>
                    <span>already using our platform</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* ============================================
           MODERN CTA SECTION
        ============================================ */
        .modern-cta-section {
          padding: 80px 0;
          background: #ffffff;
        }

        /* CTA Card */
        .cta-card-modern {
          position: relative;
          background: linear-gradient(135deg, #E91E63 0%, #E91E64 50%, #c41849 100%);
          border-radius: 32px;
          padding: 60px 48px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(245, 166, 35, 0.3);
        }

        /* Background Decorations */
        .cta-decoration {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
        }

        .decoration-1 {
          width: 400px;
          height: 400px;
          top: -150px;
          right: -100px;
          animation: float 20s ease-in-out infinite;
        }

        .decoration-2 {
          width: 300px;
          height: 300px;
          bottom: -100px;
          left: -80px;
          animation: float 15s ease-in-out infinite reverse;
        }

        .decoration-3 {
          width: 200px;
          height: 200px;
          top: 50%;
          left: 30%;
          animation: float 25s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -30px) scale(1.1);
          }
          66% {
            transform: translate(-30px, 30px) scale(0.9);
          }
        }

        /* CTA Content */
        .cta-content {
          position: relative;
          z-index: 1;
        }

        .cta-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 600;
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        .cta-badge i {
          font-size: 18px;
        }

        .cta-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800;
          color: white;
          margin-bottom: 20px;
          line-height: 1.2;
          letter-spacing: -0.02em;
        }

        .gradient-text-white {
          background: linear-gradient(135deg, #fff 0%, rgba(255, 255, 255, 0.8) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .cta-description {
          font-size: clamp(1rem, 2vw, 1.15rem);
          color: rgba(255, 255, 255, 0.95);
          line-height: 1.7;
          margin-bottom: 28px;
        }

        /* Benefits List */
        .cta-benefits {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .benefit-item {
          display: flex;
          align-items: center;
          gap: 10px;
          color: white;
          font-size: 15px;
          font-weight: 500;
        }

        .benefit-item i {
          font-size: 20px;
          color: rgba(255, 255, 255, 0.9);
        }

        /* CTA Actions */
        .cta-actions {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .cta-button {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 18px 28px;
          border-radius: 14px;
          border: none;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .primary-btn {
          background: white;
          color: #c41849;
        }

        .primary-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(255, 255, 255, 0.3);
        }

        .secondary-btn {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          color: white;
          border: 2px solid rgba(255, 255, 255, 0.3);
        }

        .secondary-btn:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-3px);
        }

        .cta-button i {
          font-size: 20px;
        }

        /* Trust Section */
        .cta-trust {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .trust-avatars {
          display: flex;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          border: 2px solid #c41849;
          margin-left: -10px;
        }

        .avatar:first-child {
          margin-left: 0;
        }

        .trust-text {
          display: flex;
          flex-direction: column;
          color: white;
        }

        .trust-text strong {
          font-size: 14px;
          font-weight: 700;
        }

        .trust-text span {
          font-size: 12px;
          opacity: 0.9;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .modern-cta-section {
            padding: 60px 0;
          }

          .cta-card-modern {
            padding: 48px 32px;
          }
        }

        @media (max-width: 767px) {
          .cta-card-modern {
            padding: 40px 24px;
          }

          .cta-benefits {
            margin-bottom: 24px;
          }

          .trust-avatars {
            display: none;
          }
        }
      `}</style>
    </section>
  );
};

export default CallToAction;